import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import MyModal from 'components/MyModal';
import React, { useState, memo } from 'react';
import { toast } from 'react-toastify';
import affiliateService from 'v2/services/affiliate';

import type { IAffiliate } from 'v2/interfaces/affiliate';

import styles from './styles';

interface IProps {
  closeModal: Function;
  active: boolean;
  affiliatesSelected: Array<IAffiliate>;
}

const ModalNewMessage = ({ closeModal, active, affiliatesSelected }: IProps) => {
  const classes = styles({});

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [sendEmail, setSendEmail] = useState(false);

  const handleClickNew = () => {
    if (!message) {
      toast.info('Escreva sua mensagem');
      return;
    }

    setLoading(true);

    const affiliates = affiliatesSelected.map((a) => a.affiliate_id);

    affiliateService.sendMessageBroadcast(message, affiliates, sendEmail).subscribe(
      () => {
        toast.success('Mensagem enviada com sucesso');
        setLoading(false);
        setMessage('');
        setSendEmail(false);
        closeModal();
      },
      (err) => {
        toast.error(err);
        setLoading(false);
      }
    );
  };

  const handleChangeMessage = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const handleChangeSendEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSendEmail(event.target.checked);
  };

  if (!active) {
    return null;
  }

  return (
    <MyModal
      hasActive
      title='Nova mensagem para afiliados'
      closeModal={closeModal}
      textButtonOk='Enviar'
      hasButtons
      handleClickOk={handleClickNew}
      loading={loading}
    >
      <div className={classes.modal}>
        <Grid container direction='row' spacing={1}>
          <Grid item xs={12}>
            <label>Texto da mensagem</label>
            <div className='m4'></div>
            <textarea className={classes.textarea} onChange={handleChangeMessage} value={message} />
            <Checkbox
              checked={sendEmail}
              onChange={handleChangeSendEmail}
              value='send-email'
              color='primary'
              style={{ padding: 0, width: 32, height: 32 }}
            />{' '}
            <span style={{ fontSize: 13 }}>Enviar cópia por e-mail</span>
          </Grid>
        </Grid>
      </div>
    </MyModal>
  );
};

export default memo(ModalNewMessage);
